import { gql } from '@apollo/client';

const TASK_FIELDS = gql`
  fragment WorkbenchTaskFields on WorkbenchTaskType {
    taskId
    source
    taskCode
    title
    detail
    category
    status
    priority
    isOverdue
    overdueMinutes
    windowStartAt
    windowEndAt
    progressCurrent
    progressTotal
    exceptionCount
    exceptionRoute
    actionCode
    actionRoute
    howToStepCount
    requirePhotoProof
    completedAt
    completedByName
    canComplete
    canReopen
  }
`;

const ALERT_FIELDS = gql`
  fragment WorkbenchAlertFields on WorkbenchAlertType {
    alertId
    alertTypeCode
    params
    source
    metricKey
    metricLabel
    metricValueText
    riskTag
    severity
    headline
    contextText
    recommendedAction
    entities {
      entityType
      entityId
      entityName
      primaryValue
      secondaryValue
      dspName
      rate
      stayMinutes
      subEntities {
        entityType
        entityId
        entityName
        primaryValue
        secondaryValue
        dspName
      }
    }
    trend {
      label
      value
    }
    actions {
      actionCode
      label
      style
      targetType
      targetValue
      targetDisplayName
    }
    triggerReason
    baselineMethod
    confidence
    firstDetectedAt
    lastDetectedAt
    consecutiveDays
    resolvedAt
    handleStatus
    handledByName
    handledAt
    actionTaken
    comment {
      content
      byId
      byName
      at
      updatedAt
      canEdit
    }
  }
`;

/** 首屏一次拉全三栏。timeZone 取自上游，为空时前端时间文案降级为 —，不回落浏览器时钟 */
export const WORKBENCH_BOARD = gql`
  query WorkbenchBoard($warehouseId: Long!) {
    workbenchBoard(warehouseId: $warehouseId) {
      warehouseId
      bizDate
      timeZone
      serverNow
      showLiveAlerts
      showPeriodAlerts
      todayTasks {
        doneCount
        totalCount
        completionPercent
      }
      tasks {
        warehouseId
        taskDate
        serverNow
        doneCount
        totalCount
        completionPercent
        tasks {
          ...WorkbenchTaskFields
        }
        doneTasks {
          ...WorkbenchTaskFields
        }
      }
      liveAlerts {
        activeCount
        handledCount
        lastDiagnosedAt
        alerts {
          ...WorkbenchAlertFields
        }
      }
      periodAlerts {
        activeCount
        handledCount
        lastDiagnosedAt
        alerts {
          ...WorkbenchAlertFields
        }
      }
    }
  }
  ${TASK_FIELDS}
  ${ALERT_FIELDS}
`;

/** 任务栏「已完成」tab 分页 */
export const WORKBENCH_FINISHED_TASKS = gql`
  query WorkbenchFinishedTasks(
    $warehouseId: Long!
    $pageNum: Int!
    $pageSize: Int!
  ) {
    workbenchFinishedTasks(
      warehouseId: $warehouseId
      pageNum: $pageNum
      pageSize: $pageSize
    ) {
      pageNum
      pageSize
      hasMore
      items {
        ...WorkbenchTaskFields
      }
    }
  }
  ${TASK_FIELDS}
`;

/** 告警栏「已处理」/ 复盘栏「已关闭」tab 分页 */
export const WORKBENCH_HANDLED_ALERTS = gql`
  query WorkbenchHandledAlerts(
    $warehouseId: Long!
    $category: String!
    $pageNum: Int!
    $pageSize: Int!
  ) {
    workbenchHandledAlerts(
      warehouseId: $warehouseId
      category: $category
      pageNum: $pageNum
      pageSize: $pageSize
    ) {
      pageNum
      pageSize
      hasMore
      items {
        ...WorkbenchAlertFields
      }
    }
  }
  ${ALERT_FIELDS}
`;

/** 「加载更多」每次追加条数，与后端 workbenchFinishedTasks 的默认 pageSize 一致 */
export const WORKBENCH_PAGE_SIZE = 50;
